var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBancoComafi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 6.94,
    cy: 15.03,
    fx: 6.94,
    fy: 15.03,
    r: 7.87,
    gradientTransform: "translate(0 22) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adc46a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#657733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384125"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 23.97,
    cy: 7.84,
    fx: 23.97,
    fy: 7.84,
    r: 6.33,
    gradientTransform: "translate(-15.12 16.81) scale(.98 -1.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#dfe4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#a1ae8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#728551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#556c31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a642e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 24.51,
    cy: 17.17,
    fx: 24.51,
    fy: 17.17,
    r: 6.35,
    gradientTransform: "translate(-15.6 25.6) scale(.98 -.98)",
    xlinkHref: "#radial-gradient-2"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84,8.77c.16-.23.23-.47.23-.62q0-.08-.08-.16c-.16-.08-.47,0-.78.23v-1.09c.31.23.62.39.78.23,0,0,.08-.08.08-.16,0-.16-.08-.39-.31-.54h1.09c-.16.23-.23.47-.23.62q0,.08.08.16c.08.08.47,0,.78-.23v1.09c-.31-.23-.62-.39-.78-.23,0,0-.08.08-.08.16,0,.16.08.39.31.54h-1.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 8.69,
    cy: 8.96,
    r: 4.68,
    style: {
      fill: "url(#radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55,14.44h.1c2.88,0,5.23-2.32,5.37-5.29h-5.46v5.29h0Z",
    style: {
      fill: "url(#radial-gradient-2)",
      isolation: "isolate",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.01,8.81c-.06-2.91-2.44-5.25-5.37-5.25h-.1v5.25h5.46Z",
    style: {
      fill: "url(#radial-gradient-3)",
      isolation: "isolate",
      opacity: 0.65
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancoComafi);
export default __webpack_public_path__ + "static/media/banco-comafi.ac291e5973a9213de910fe227e4a8789.svg";
export { ForwardRef as ReactComponent };